import { ChangeEvent } from "react";
import { FaSearch } from "react-icons/fa";
import { IoMdClose } from "react-icons/io"; // Icono para la X
import styles from "./InputSearch.module.scss";

interface InputSearchProps {
  value: string;
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handleClear: () => void; // Nueva prop para borrar
}

export const InputSearch = ({
  value,
  handleChange,
  handleClear,
}: InputSearchProps) => {
  return (
    <div className={styles.inputWrapper}>


      <input
        value={value}
        placeholder="¿Qué te gustaría pedir?"
        className={styles.inputSearch}
        onChange={handleChange}

      />

      {/* Si hay texto, mostramos la X */}
      {value.length > 0 && (
        <IoMdClose
          className={styles.clearIcon}
          onClick={handleClear}
        />
      )}
    </div>
  );
};